/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayLaneStatDtoSchema = z.object({
  key: z.string().nullish(),
  blueValue: z.number().nullish(),
  redValue: z.number().nullish(),
  leadingSide: z.string().nullish(),
  delta: z.number().nullish(),
});
